import * as Application from 'expo-application';
import compareVersions from "compare-versions";
import HelperPlatform from 'utils/helper-platform'
import _ from 'lodash'
import VersionJson from 'version.json'

const HelperVersion = {
	
	get: () => {
		if( HelperPlatform.isWeb() ) {
			return HelperVersion.getBuildVersion()
		}
		
		return `${ HelperVersion.getNativeAppVersion() } (${ HelperVersion.getBuildVersion() })`
	},

	getNativeAppVersion: () => {
		return Application?.nativeBuildVersion ?? '?';
	},

	getBuildVersion: () => {
		return VersionJson?.version ?? ''
	},
	
	isTestVersion: () => {
		return _.includes( HelperVersion.getBuildVersion(), 'beta' );
	},
	
	compareVersions: (a, b) => {
		if (a === b) {
			return 0;
		}
		
		let a_components = a.split(".");
		let b_components = b.split(".");
		
		let len = Math.min(a_components.length, b_components.length);
		
		// loop while the components are equal
		for (let i = 0; i < len; i++) {
			// A bigger than B
			if (parseInt(a_components[i]) > parseInt(b_components[i])) {
				return 1;
			}
			
			// B bigger than A
			if (parseInt(a_components[i]) < parseInt(b_components[i])) {
				return -1;
			}
		}
		
		// If one's a prefix of the other, the longer one is greater.
		if (a_components.length > b_components.length) {
			return 1;
		}
		
		if (a_components.length < b_components.length) {
			return -1;
		}
		
		// Otherwise they are the same.
		return 0;
	},
	
	
	/**
	 * Function for comparing the build version to the given version
	 * @param version
	 * @returns {boolean}
	 */
	compareBuild: ( version ) => {
		if( typeof version !== 'string' ) {
			return true;
		}
		
		const bVersion = HelperVersion.getBuildVersion();
		if( typeof bVersion !== 'string' ) {
			return true;
		}
		
		return compareVersions.compare( bVersion, version, '>=' );
	},
	
	/**
	 * Function for comparing the app version to the given version
	 * @param version
	 * @returns {boolean}
	 */
	compareApp: ( version ) => {
		if( typeof version !== 'string' ) {
			return true;
		}
		
		const bVersion = HelperVersion.getNativeAppVersion();
		if( typeof bVersion !== 'string' ) {
			return true;
		}
		
		return compareVersions.compare( HelperVersion.getNativeAppVersion(), version, '>=' );
	}
}

export default HelperVersion
